import React from "react";

const CloseIcon = () => {
  return (
    <svg width="12px" height="12px" viewBox="0 0 12 12">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-85.000000, -310.000000)" fill="#757575">
          <g transform="translate(91.000000, 316.000000) rotate(45.000000) translate(-91.000000, -316.000000) translate(84.000000, 309.000000)">
            <polygon
              transform="translate(7.000000, 7.000000) rotate(-3.000000) translate(-7.000000, -7.000000) "
              points="6.02040816 0.142857143 7.97959184 0.142857143 7.97959184 13.8571429 6.02040816 13.8571429"
            ></polygon>
            <polygon
              transform="translate(7.000000, 7.000000) rotate(3.000000) translate(-7.000000, -7.000000) "
              points="0.142857143 6.02040816 13.8571429 6.02040816 13.8571429 7.97959184 0.142857143 7.97959184"
            ></polygon>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CloseIcon;
